// Two kinds of stored dates need different handling:
//
//  • System timestamps (opened_at, closed_at, activity/comment created_at,
//    uploaded_at) come from SQLite datetime('now') as 'YYYY-MM-DD HH:MM:SS' in
//    UTC with no zone marker. Use formatDateTime / formatUtcDate — they treat the
//    value as UTC and render in the viewer's local time.
//
//  • incident_date (the wall-clock the technician picked) and pure date ranges
//    ('YYYY-MM-DD') carry no zone and should display exactly as entered. Use
//    formatDate — it does no timezone conversion.

function parseLocal(value: string): Date | null {
  const iso = value.includes('T') ? value : value.replace(' ', 'T')
  const withTime = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? `${iso}T00:00:00` : iso
  const d = new Date(withTime)
  return Number.isNaN(d.getTime()) ? null : d
}

// Treat a zone-less DB timestamp as UTC so it converts to local correctly.
function parseUtc(value: string): Date | null {
  let s = value.includes('T') ? value : value.replace(' ', 'T')
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) s += 'T00:00:00'
  if (!/[zZ]|[+-]\d\d:?\d\d$/.test(s)) s += 'Z'
  const d = new Date(s)
  return Number.isNaN(d.getTime()) ? null : d
}

// Wall-clock / pure date — shown as entered, no conversion.
export function formatDate(value: string | null | undefined): string {
  if (!value) return '—'
  const d = parseLocal(value)
  return d
    ? d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
    : value
}

// UTC system timestamp — date only, in the viewer's local time.
export function formatUtcDate(value: string | null | undefined): string {
  if (!value) return '—'
  const d = parseUtc(value)
  return d
    ? d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })
    : value
}

// UTC system timestamp — date + time, in the viewer's local time.
export function formatDateTime(value: string | null | undefined): string {
  if (!value) return '—'
  const d = parseUtc(value)
  return d
    ? d.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })
    : value
}

export function formatMoney(n: number | null | undefined): string {
  if (n == null) return '—'
  return n.toLocaleString(undefined, { style: 'currency', currency: 'USD' })
}
